// src/components/nav/ToolBackControl.tsx
import React from "react";
import { useRouter } from "next/router";
import { ArrowLeft } from "lucide-react";
import { handleSafeBack } from "@/lib/nav/navigationUtils";
import { cn } from "@/lib/utils";

interface ToolBackControlProps {
    className?: string;
    fallback?: string;
    label?: string;
    subtitle?: string;
}

export function ToolBackControl({
    className,
    fallback = "/dashboard",
    label = "Back",
    subtitle = "Return to where you left off",
}: ToolBackControlProps) {
    const router = useRouter();

    return (
        <button
            onClick={() => handleSafeBack(router, fallback)}
            className={cn(
                "group flex items-center gap-3 px-4 py-2 rounded-xl transition-all duration-200",
                "bg-white/90 dark:bg-[#123733]/90 backdrop-blur-sm border border-gray-200 dark:border-[#D5BF76]/20",
                "hover:shadow-lg hover:border-teal-300 dark:hover:border-[#D5BF76]/50 shadow-sm",
                className
            )}
        >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-teal-100 dark:bg-[#D5BF76]/10 text-teal-600 dark:text-[#D5BF76] group-hover:bg-teal-200 dark:group-hover:bg-[#D5BF76]/20 transition-colors">
                <ArrowLeft className="w-5 h-5 transition-transform group-hover:-translate-x-1" />
            </div>
            <div className="flex flex-col items-start leading-tight">
                <span className="text-sm font-black text-gray-900 dark:text-white">
                    {label}
                </span>
                {subtitle && (
                    <span className="text-[10px] font-bold text-gray-500 dark:text-[#D5BF76]/60 uppercase tracking-wider">
                        {subtitle}
                    </span>
                )}
            </div>
        </button>
    );
}
